import React, { useState } from "react";
import { useSelector } from "react-redux";
import styles from "./AllApproval/ViewAllLessPlanApproval/ViewLessonPlanApproval.module.css";
import { FaClipboardList } from "react-icons/fa";
import { CustomTab } from "../../../../components";
import TeacherWiseApprovalList from "./TeacherwiseApproval/TeacherwiseApprovalList";
import AllLessonPlanApprovalList from "./AllApproval/AllLessonApprovalList";
import ClassWiseApprovalList from "./ClassWiseApproval/ClassWiseApprovalList";

function LessonPlanApprovalList() {
  const { translations } = useSelector((state) => state.language);
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: translations?.labels?.tabAll || "All",
      content: <AllLessonPlanApprovalList />,
    },
    {
      label: translations?.labels?.tabClasswise || "Class-wise",
      content: <ClassWiseApprovalList />,
    },
    {
      label: translations?.labels?.tabTeacherwise || "Teacher-wise",
      content: <TeacherWiseApprovalList />,
    },
  ];

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <FaClipboardList />
        </div>
        <h1 className={styles.headerTitle}>
          {translations?.labels?.lessonPlan || "Lesson Plan"}
        </h1>
      </div>

      {/* Tabs */}
      <CustomTab
        tabs={tabs}
        defaultActiveTab={0}
        onTabChange={(i) => setActiveTab(i)}
      />
    </div>
  );
}

export default LessonPlanApprovalList;
